import type { LocaleCode, LocaleDefinition } from "../types";

import { LOCALE_CONSENT_CONFIG_BY_CODE } from "../consent/locale-consent-configs";

const DEFAULT_LOCALE_CODE: LocaleCode = "us-en";

/**
 * Seed locale definitions. Country, domain, and URL shapes are derived from
 * `LocaleCode` via `derive-locale-metadata.ts`.
 */
const LOCALE_DEFINITIONS: LocaleDefinition[] = [
  {
    code: DEFAULT_LOCALE_CODE,
    consent: LOCALE_CONSENT_CONFIG_BY_CODE["us-en"],
  },
  {
    code: "ca-en",
    consent: LOCALE_CONSENT_CONFIG_BY_CODE["ca-en"],
  },
  {
    code: "ie-en",
    consent: LOCALE_CONSENT_CONFIG_BY_CODE["ie-en"],
  },
];

export { DEFAULT_LOCALE_CODE, LOCALE_DEFINITIONS };
